import React, { useState } from "react";
import colors from "../../../utils/colors";
import SearchBar from "../../../components/ui/searchBar";
import { FaSearch, FaArrowLeft } from "../../../components/icons";

interface IProps {
  active: string;
  setActive: React.Dispatch<React.SetStateAction<string>>;
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  searchPlaceholder: string;
}

const AppointmentTabs = ({
  active,
  setActive,
  search,
  setSearch,
  setPage,
  searchPlaceholder,
}: IProps) => {
  const tabs = ["Upcoming", "Past "];
  const { dark, primary } = colors;
  const [isMobileSearchActive, setIsMobileSearchActive] = useState(false);

  if (isMobileSearchActive) {
    return (
      <div className="flex items-center px-3 mb-2 h-[56px]">
        <button
          onClick={() => setIsMobileSearchActive(false)}
          className="p-2 mr-2 text-gray-600 hover:text-gray-800"
          aria-label="Close search"
        >
          <FaArrowLeft size={20} />
        </button>
        <div className="flex-grow">
          <SearchBar
            className="w-full"
            height="40px"
            width="100%"
            handleChange={(e) => {
              if (typeof setSearch === "function") setSearch(e);
              if (typeof setPage === "function") setPage(1);
            }}
            placeholderText={searchPlaceholder}
            value={search}
            // autoFocus
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-between items-center px-3 mb-2 h-[56px]">
      <div className="flex gap-2 cursor-pointer">
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`p-3 ${
              active === tab?.trim().toLowerCase() && "border-b-[3px]"
            }`}
            style={{
              borderBottomColor: primary,
              color: active === tab?.trim().toLowerCase() ? primary : dark,
            }}
            // onClick={() => setActive(tab?.trim().toLowerCase())}
            onClick={() => {
              setActive(tab?.trim().toLowerCase());
              setPage(1); // 👈 reset pagination when switching tabs
            }}
          >
            {tab.trim()}
          </div>
        ))}
      </div>

      <div className="hidden sm:block w-full sm:w-auto sm:max-w-xs">
        <SearchBar
          className=""
          height="40px"
          width="100%"
          handleChange={(e) => {
            if (typeof setSearch === "function") setSearch(e);
            if (typeof setPage === "function") setPage(1);
          }}
          placeholderText={searchPlaceholder}
          value={search}
        />
      </div>

      <div className="sm:hidden">
        <button
          onClick={() => setIsMobileSearchActive(true)}
          className="p-3 text-gray-600 hover:text-gray-800"
          aria-label="Open search"
        >
          <FaSearch size={20} />
        </button>
      </div>
    </div>
  );
};

export default AppointmentTabs;
